window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};

repos.casinoBonusRepo = function () {

    var url = 'api/casinobonusi';

    var get = function (campaignName) {

        return fetch(url + casino.repos.base.serializeGetParams({ campaignName: campaignName }),
            {
            credentials: repos.base.credentials
            })
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

    };

    return {
        get: get
    }
}();